import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_3 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_7 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_8 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_11 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_12 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_18 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_19 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_20 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_21 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_marca_modelo = _resolveComponent("selecionar-marca-modelo")!
  const _component_selecionar_cor_veiculo = _resolveComponent("selecionar-cor-veiculo")!
  const _component_selecionar_tipo_pintura = _resolveComponent("selecionar-tipo-pintura")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_tipo_combustivel = _resolveComponent("selecionar-tipo-combustivel")!
  const _component_selecionar_tipo_restricao = _resolveComponent("selecionar-tipo-restricao")!
  const _component_selecionar_condicao_v_i_n = _resolveComponent("selecionar-condicao-v-i-n")!
  const _component_selecionar_condicao_veiculo = _resolveComponent("selecionar-condicao-veiculo")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: "Detalhes do Veículo" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form_item, {
            label: "Chassi",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.chassi) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeVeiculo.chassi]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_form_item, {
            label: "Número do Motor",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.numeroMotor) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeVeiculo.numeroMotor]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_form_item, {
            label: "Serial",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.serial) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeVeiculo.serial]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_form_item, {
            label: "Marca/Modelo",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_marca_modelo, {
                codigoSelecionado: _ctx.state.codigoModelo,
                "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoModelo) = $event)),
                empresas: [_ctx.props.empresa],
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.obterDadosModelo()))
              }, null, 8, ["codigoSelecionado", "empresas"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_form_item, {
            label: "Cor Veiculo",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_cor_veiculo, {
                codigoSelecionado: _ctx.state.codigoCor,
                "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.codigoCor) = $event)),
                empresas: [_ctx.props.empresa],
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.obterDadosCor()))
              }, null, 8, ["codigoSelecionado", "empresas"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_form_item, {
            label: "Tipo Pintura",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_tipo_pintura, {
                valor: _ctx.state.tipoPintura,
                "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.tipoPintura) = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.obterTipoPintura()))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_form_item, {
            label: "Cilindradas",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "ant-input",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.cilindradas) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.computedRastreabilidadeVeiculo.cilindradas,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_form_item, {
            label: "Potência (CV)",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "ant-input",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.potenciaCV) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.computedRastreabilidadeVeiculo.potenciaCV,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_form_item, {
            label: "Distância entre eixos",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "ant-input",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.distanciaEntreEixos) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.computedRastreabilidadeVeiculo.distanciaEntreEixos,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_a_form_item, {
            label: "Capacitade Máx Tração",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.computedRastreabilidadeVeiculo.capacidadeMaximaTracao,
                "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.capacidadeMaximaTracao) = $event)),
                quantidadeCasasDecimais: 4
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_form_item, {
            label: "Peso Bruto",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.computedRastreabilidadeVeiculo.pesoBruto,
                "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.pesoBruto) = $event)),
                quantidadeCasasDecimais: 4
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_form_item, {
            label: "Peso Liquido",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.computedRastreabilidadeVeiculo.pesoLiquido,
                "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.pesoLiquido) = $event)),
                quantidadeCasasDecimais: 4
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_a_form_item, {
            label: "Tipo de Combustível",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_tipo_combustivel, {
                valor: _ctx.computedRastreabilidadeVeiculo.tipoCombustivel,
                "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.tipoCombustivel) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_a_form_item, {
            label: "Tipo Restricao",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_tipo_restricao, {
                valor: _ctx.computedRastreabilidadeVeiculo.tipoRestricao,
                "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.tipoRestricao) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_a_form_item, {
            label: "Condição VIN",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_condicao_v_i_n, {
                valor: _ctx.computedRastreabilidadeVeiculo.condicaoVin,
                "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.condicaoVin) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_a_form_item, {
            label: "Condição Veículo",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_condicao_veiculo, {
                valor: _ctx.computedRastreabilidadeVeiculo.condicaoVeiculo,
                "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedRastreabilidadeVeiculo.condicaoVeiculo) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_a_form_item, {
            label: "Quantidade",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.computedQtdRastreabilidade,
                "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedQtdRastreabilidade) = $event)),
                quantidadeCasasDecimais: _ctx.props.qtdCasasDecimais
              }, null, 8, ["valor", "quantidadeCasasDecimais"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}